// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___7d7f54a3a63fd4c0a22","cls2":"ImpactHubModal-cls2__b5ecabbd96ef0426cf80 ImpactHubModal-cls1___7d7f54a3a63fd4c0a22"};